'use client';

import { QueryKeys } from '@/constants/query-keys';
import { SharedState } from '@/types/shared-state';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

type SharedStateProviderProps = {
  initialSharedState: SharedState;
};

export const SharedStateProvider = ({ initialSharedState }: SharedStateProviderProps): null => {
  const queryClient = useQueryClient();

  useEffect(() => {
    queryClient.setQueryData(QueryKeys.user.sharedState, initialSharedState);
  }, [queryClient, initialSharedState]);

  return null;
};
